// Customer demos contain synthetic auth and legacy product surfaces. Keep them
// behind an explicit flag even during local development so they can never be
// mistaken for the invite-only product or accidentally ship in a preview.
const demoRoutesEnabled = import.meta.env.VITE_ENABLE_DEMO_ROUTES === 'true'

export function clearDemoMode() {
  if (typeof window === 'undefined') return

  window.sessionStorage.removeItem('onzoeDemoMode')
  window.sessionStorage.removeItem('isAuthenticated')
  window.sessionStorage.removeItem('userData')
}

export function isDemoModeEnabled() {
  if (typeof window === 'undefined') return false
  if (!demoRoutesEnabled) {
    clearDemoMode()
    return false
  }

  const hasDemoFlag = window.sessionStorage.getItem('onzoeDemoMode') === 'true'
  const hasLegacyDemoAuth =
    window.sessionStorage.getItem('isAuthenticated') === 'true' &&
    Boolean(window.sessionStorage.getItem('userData'))

  return hasDemoFlag || hasLegacyDemoAuth
}

export { demoRoutesEnabled }
